import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as arrow_right_top} from '../../../assets/arrows/edit/arrow_right_top.svg';

const ArrowRightTop: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} component={arrow_right_top} viewBox='0 0 107 114' />
  );
};

export default ArrowRightTop;
